import Router from '../routing/Router'
import { useAppSelector } from '../../store/Hooks'
import RoutingManager from '../routing/Routing'

function LayoutContent() {
    const route = useAppSelector(s => s.session.currentRoute)
    const routeInfo = RoutingManager.get(route)

    return (
        <main className='layout-content'>
            <div className='layout-content-page' style={{ padding: routeInfo?.fullScreen ? 0 : undefined }}>
                <Router />
            </div>
        </main>
    )
}

export default LayoutContent
